import React from "react";
import { Tooltip } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import EditNoteIcon from "@mui/icons-material/EditNote";
import { DataField } from "./DataField";
import { tooltipTheme } from "../utils/tooltipTheme";

export const EditableFieldRow = (props) => {

    const { label, field, canEdit, onEdit, tooltipText, iconId } = props

    return (
        <div className="editable-field-row">
            {field &&
                <DataField
                    label={label}
                    field={field}
                />}
            {canEdit &&
                <ThemeProvider theme={tooltipTheme}>
                    <Tooltip title={tooltipText} placement="top">
                        <button
                            className="btn btn--white btn--animated editable-field-row__edit-button"
                            onClick={onEdit}
                        >
                            <EditNoteIcon id={iconId} style={{ width: "1.8rem" }} />
                        </button>
                    </Tooltip>
                </ThemeProvider>
            }
        </div>
    )
}
